import { render, staticRenderFns } from "./Registros-Funcionario.vue?vue&type=template&id=130280bd&scoped=true&"
import script from "./Registros-Funcionario.vue?vue&type=script&lang=js&"
export * from "./Registros-Funcionario.vue?vue&type=script&lang=js&"
import style0 from "./Registros-Funcionario.vue?vue&type=style&index=0&id=130280bd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130280bd",
  null
  
)

export default component.exports